import { render, staticRenderFns } from "./wl_award.vue?vue&type=template&id=eb182c5e&scoped=true"
import script from "./wl_award.vue?vue&type=script&lang=js"
export * from "./wl_award.vue?vue&type=script&lang=js"
import style0 from "./wl_award.vue?vue&type=style&index=0&id=eb182c5e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb182c5e",
  null
  
)

export default component.exports